import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAffiliate } from '../api/affiliates/useAffiliate';
import { useEffect } from 'react';
import { Loader } from './Loader';
import { useApplication } from '../api/applications/useApplication';
import { useFormData } from '../utils/formReducer';
import { FORM_ACTIONS } from '../utils/formActions';
import { useBirthdayInput } from './OnboardingForm/components/BirthdayInput/useBirthdayInput';
import { AMAZON_HBC_SOURCE } from '../constants/utms';

export const CustomAccount = () => {
  const { applicationId } = useParams();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('sessionId');
  const { dispatch } = useFormData();
  const { handleBirthdayChange } = useBirthdayInput();
  const navigate = useNavigate();

  const {
    affiliate,
    isInitialLoading: affiliateInitialLoading,
    isLoading: affiliateLoading,
    isError: isAffiliateError,
  } = useAffiliate({
    affiliateId: AMAZON_HBC_SOURCE,
  });

  const {
    application,
    isInitialLoading: applicationInitialLoading,
    isLoading: applicationLoading,
    isError: isApplicationError,
  } = useApplication({
    applicationId,
    sessionId,
  });

  const utmSource = affiliate?.utm_source;

  const isLoading =
    affiliateInitialLoading ||
    affiliateLoading ||
    applicationInitialLoading ||
    applicationLoading;

  useEffect(() => {
    if (application && utmSource) {
      // set form values if valid application is found
      dispatch({
        type: FORM_ACTIONS.UPDATE_FORM_FIELD,
        fieldName: 'firstName',
        payload: application.first_name,
      });

      dispatch({
        type: FORM_ACTIONS.UPDATE_FORM_FIELD,
        fieldName: 'lastName',
        payload: application.last_name,
      });

      dispatch({
        type: FORM_ACTIONS.UPDATE_FORM_FIELD,
        fieldName: 'email',
        payload: application.email_address,
      });

      // dob is "YYYY-MM-DD" so reformat to "MMDDYYYY"
      const [year, month, day] = application.date_of_birth.split('-');
      if (year && month && day) {
        handleBirthdayChange(month + day + year);
      }

      // redirect after setting form values
      navigate(`/onboarding?utm_source=${utmSource}`, { replace: true });
    }
  }, [application, utmSource, navigate, dispatch, handleBirthdayChange]);

  useEffect(() => {
    if (isApplicationError || isAffiliateError) {
      navigate(`/?utm_source=${utmSource}`, {
        state: {
          customAccountError:
            "We've encountered an error. Please return to Amazon HBC and restart the application process.",
        },
        replace: true,
      });
    }
  }, [isApplicationError, isAffiliateError, utmSource, navigate]);

  if (isLoading) {
    return <Loader label={'Checking affiliate'} loading={affiliateLoading} />;
  }

  return null;
};

export default CustomAccount;
